import classNames from "classnames";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { getUnreadNotifications } from "../../helpers/common";
import SmallLoader from "../../helpers/Common/SmallLoader";
import NotificationListing from "./NotificationListing";
import NotificationPopup from "./NotificationPopup"; // 🟢 NEW

const NotificationContent = () => {
  const notificationsReducer = useSelector((state) => state.notifications);
  const notificationsList = notificationsReducer.data;
  const loading = notificationsReducer.loading;

  const [activeTab, setActiveTab] = useState("1");
  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // 🟢 NEW: popup state lifted here, so it survives NotificationListing unmount/remount
  // (which happens whenever "loading" flips true/false after a mark-read/delete call)
  const [selectedNotification, setSelectedNotification] = useState(null);

  const unreadNotifications = getUnreadNotifications(notificationsList);

  return (
    <div className="container my-5">
      <div className="notification-card p-0 ">
        <Nav
          tabs
          className="job-list-menu nav-pills nav-justified flex-column flex-sm-row mb-4"
          id="pills-tab"
          role="tablist"
        >
          <NavItem role="presentation">
            <NavLink
              className={classNames({ active: activeTab === "1" })}
              onClick={() => {
                tabChange("1");
              }}
              id="all-application-tab"
              type="button"
              role="tab"
            >
              All
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            {loading ? (
              <SmallLoader />
            ) : (
              <NotificationListing
                notificationsList={notificationsList}
                onOpenNotification={setSelectedNotification} // 🟢 NEW
              />
            )}
          </TabPane>

          <TabPane tabId="2">
            {loading ? (
              <SmallLoader />
            ) : (
              <NotificationListing
                notificationsList={unreadNotifications}
                onOpenNotification={setSelectedNotification} // 🟢 NEW
              />
            )}
          </TabPane>
        </TabContent>
      </div>

      {/* 🟢 NEW: popup lives at this level, so it's unaffected by child remounts */}
      <NotificationPopup
        selectedNotification={selectedNotification}
        onClose={() => setSelectedNotification(null)}
      />
    </div>
  );
};

export default NotificationContent;